<template>
  <section class="quotewizard">
    <div class="container purchasesummary-end">
      <br /><br /><br />
      <div
        v-if="quote.hasPersonalInsurance"
        class="title"
        style="text-align: center; color: #333"
      >
        Done! Your policies are all set.
      </div>
      <div v-else class="title" style="text-align: center; color: #333">
        Done! Your policy is all set.
      </div>
      <p style="text-align: center; margin-top: 4px; line-height: 22px">
        Thank you for your purchase. We'll email you a confirmation of your
        policy.
      </p>
      <br />
      <br />
      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="mobilecollpasetable"
      >
        <tbody>
          <tr>
            <td width="48%" valign="top" class="success">
              <!---------- message --->
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td width="20%" valign="top">
                      <span class="bigsuccess-checkmark"></span>
                    </td>
                    <td valign="top">
                      <strong>Your Renters Insurance</strong>
                      <ul>
                        <li>Property Damage &amp; Personal Liability</li>
                        <li>Personal Property Coverage</li>
                      </ul>
                      <b>Success! You're Covered.</b>
                      <br />
                      <br />
                      <span
                        style="color: #777; font-size: 13px; line-height: 18px"
                      >
                        <b>Bank Statement Notice:</b><br />
                        Transaction may appear as "AGI* Renters/Condo Ins".
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <br />
              <!---------- message --->
            </td>
            <td v-if="quote.hasPersonalInsurance" valign="top" class="success">
              <!---------- message --->
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td width="20%" valign="top">
                      <span class="bigsuccess-checkmark"></span>
                    </td>
                    <td valign="top">
                      <strong>Your Personal Property Coverage Add-On</strong>
                      <ul>
                        <li>Accidental Damage Add-On</li>
                      </ul>
                      <b>Success! You're Covered.</b>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!---------- message --->
            </td>
          </tr>
        </tbody>
      </table>
      <br /><br />
      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="gold notice"
      >
        <tbody>
          <tr>
            <td>
              <button target="_blank" @click="generateOrderPdf">
                View your order receipt (PDF)
              </button>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <button target="_blank" @click="generateApplicationPdf">
                View your application (PDF)
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="notice"
      >
        <tbody>
          <tr>
            <td v-if="!quote.hasPersonalInsurance">
              To manage your policy, use
              <a href="https://manage.myassurantpolicy.com/" target="_blank">
                MyAssurantPolicy
              </a>
              .
            </td>
            <td v-else>
              To manage your policies, visit
              <a href="https://manage.myassurantpolicy.com/" target="_blank">
                MyAssurantPolicy
              </a>
              for renter insurance &amp; use
              <a
                href="https://www.nssi.com/customer/account/login/"
                target="_blank"
                >NSSI.com
              </a>
              for your accidental damage coverage add-on.
            </td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { EmailService } from "@/api/EmailService";
import { ReceiptService } from "@/api/ReceiptService";
//import { getReceipts } from "@/services/Functions";
import { onMounted, watch, ref, Ref } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import { useGtag } from "vue-gtag-next";

const props = defineProps({
  anchor: {
    type: String,
    default: "",
  },
});

const title = "Done";
const applicationPdfLink: Ref<string> = ref("");
const orderLink: Ref<string> = ref("");
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;
const gtag = useGtag();

const getReceipt = async () => {
  //TODO get links and reusable function
  const response = await ReceiptService.getReceiptLink(quote);
  if (response.error === false) {
    applicationPdfLink.value = response.result.application_pdf_link;
    orderLink.value = response.result.order_link;
  }
};

watch(quote, (current) => {
  //If purchase is succesful,logs out
  if (current.done) {
    track(current);
    userStore.logout();
    sessionStorage.removeItem("log");
  }
});

onMounted(async () => {
  //Curly braces were missing after if here
  if (!quote.done) {
    await getReceipt();
    EmailService.sendOrderReceipt(
      quote,
      user,
      applicationPdfLink.value,
      orderLink.value
    );
    quote.done = true;
  }
});

const generateApplicationPdf = async () => {
  if (applicationPdfLink.value !== "") {
    window.open(applicationPdfLink.value);
  }
};

const generateOrderPdf = async () => {
  if (orderLink.value !== "") {
    window.open(orderLink.value);
  }
};
const track = (current: any) => {
  try {
    if (
      !current?.rentersInsurance?.policyNumber ||
      !current?.rentersInsurance?.dueToday
    ) {
      throw new Error(
        "Invalid data structure or missing properties in 'current'."
      );
    }

    gtag.event("purchase", {
      transaction_id: current.rentersInsurance.policyNumber,
      affiliation: "Renters",
      value: current.rentersInsurance.dueToday,
      currency: "USD",
      country: "US",
    });

    console.log("Purchase event tracked by GA4!");
  } catch (error: any) {
    console.error("Error tracking purchase event:", error.message);
  }
};
</script>
